import React, { useState, useEffect } from "react";
import "./FAQs.scss";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa6";
import { useLocation, useHistory, Link } from 'react-router-dom';

const FAQWeb = () => {
  const location = useLocation();
  const booking = location.state || {};
  const [expandedAccordion, setExpandedAccordion] = useState(null);
  const [rightFaq, setRightFaq] = useState(0)

  const toggleAccordion = (accordionId) => {
    setExpandedAccordion(
      expandedAccordion === accordionId ? null : accordionId
    );
  };


  useEffect(() => {
    if (location.state !== undefined) {
      setRightFaq(location.state); // Set state from location.state
    } else {
      setRightFaq(0); // Fallback to 0 if not available
    }
  }, [location.state]);

  return (
    <>
      <div className="faqButtons">
        <div className={`faqText ${rightFaq === 0 ? 'colorBackFaq' : ''}`} onClick={() => { setRightFaq(0) }}>General FAQs</div>
        <div className={`faqText ${rightFaq === 1 ? 'colorBackFaq' : ''}`} onClick={() => { setRightFaq(1) }}>Booking Process FAQs</div>
        <div className={`faqText ${rightFaq === 2 ? 'colorBackFaq' : ''}`} onClick={() => { setRightFaq(2) }}>Payment and Security</div>
        <div className={`faqText ${rightFaq === 3 ? 'colorBackFaq' : ''}`} onClick={() => { setRightFaq(3) }}>Bus Operators FAQs</div>
        <div className={`faqText ${rightFaq === 4 ? 'colorBackFaq' : ''}`} onClick={() => { setRightFaq(4) }}>Travelers FAQs</div>
        <div className={`faqText ${rightFaq === 5 ? 'colorBackFaq' : ''}`} onClick={() => { setRightFaq(5) }}>Technical Support FAQs</div>
        <div className={`faqText ${rightFaq === 6 ? 'colorBackFaq' : ''}`} onClick={() => { setRightFaq(6) }}>Privacy and Security FAQs</div>
        <div className={`faqText ${rightFaq === 7 ? 'colorBackFaq' : ''}`} onClick={() => { setRightFaq(7) }}>Returns, Refunds, and Cancellations FAQs</div>
      </div>
      <div className="faqMain">

        {rightFaq === 0 &&
          <div className="accoprdionOuter">
            <Accordion
              expanded={expandedAccordion === 1}
              onChange={() => toggleAccordion(1)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 1 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  What is BusArabia and what services does it offer?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                BusArabia is an online bus travel agency catering to the Middle Eastern travelers. We provide a platform for travelers to search, compare, and book bus tickets across various routes in countries such as Saudi Arabia, Egypt, Jordan, Iraq, Bahrain, Turkey, Oman, UAE, and Lebanon. Bus Arabia also offers Hajj & Umrah packages, Cargo services, Tourism packages, Bus rental services and Visa services for the middle eastern countries.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 2}
              onChange={() => toggleAccordion(2)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 2 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  How does BusArabia differ from traditional bus ticket booking methods?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Unlike traditional methods wherein travelers would need to visit Bus Operator’s or agents offices, BusArabia offers a convenient online platform where travelers can easily compare bus ticket prices and bus schedules of different bus operators all in one place, enabling them to take informed decisions and book tickets hassle-free saving precious money, time and efforts.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 3}
              onChange={() => toggleAccordion(3)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 3 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Which countries does BusArabia primarily serve?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                BusArabia primarily serves the Middle Eastern countries such as Saudi Arabia, Egypt, Jordan, Iraq, Bahrain, Turkey, Oman, UAE, and Lebanon.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 4}
              onChange={() => toggleAccordion(4)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 4 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Is BusArabia exclusively for bus travel, or does it offer other transportation services?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Apart from providing a comprehensive online platform for booking bus tickets, Bus Arabia also offers Hajj & Umrah packages, Cargo services, Tourism packages, Bus rental services and Visa services for the middle eastern countries. Bus Arabia would also explore additional transportation services in the future.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 5}
              onChange={() => toggleAccordion(5)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 5 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  How can I contact BusArabia for assistance?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                You can reach out to us through our customer care email at customercare@busarabia.com for traveler inquiries and admin-related matters at admin@busarabia.com for vendor and B2B interactions.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 6}
              onChange={() => toggleAccordion(6)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 6 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Do you offer discounts for group bookings?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Yes, Bus Arabia offers attractive discounts for group bookings. Below is the step wise procedure to avail these discounts: <br /> <br />
                <span className="faqHeading"> Contact Customer Service:</span> Reach out to our customer service team via phone or email to inquire about group booking rates. Our team is available to assist you with any questions and provide detailed information about the discounts<br />
                <span className="faqHeading"> Provide Group Details:</span> Be ready to provide information about your group, including the number of passengers, travel dates, and destinations.<br />
                <span className="faqHeading"> Receive a Customized Quote:</span> Based on your provided details, our customer service team will offer a customized quote that includes the applicable group discount.<br />
                <span className="faqHeading"> Complete the Booking:</span> Once you agree to the terms and rates, our team will assist you in completing the booking process for your group.
              </AccordionDetails>
            </Accordion>


          </div>}
        {rightFaq === 1 &&
          <div className="accoprdionOuter">
            <Accordion
              expanded={expandedAccordion === 7}
              onChange={() => toggleAccordion(7)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 7 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  How do I search for bus tickets on BusArabia?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                You can easily search for bus tickets by entering your desired departure and arrival locations, travel dates, and the number of passengers on our website's search bar. The results will display available bus options for your selected route and dates.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 8}
              onChange={() => toggleAccordion(8)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 8 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Can I book tickets for multiple passengers in one transaction?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Yes, you can book tickets for multiple passengers in a single transaction by specifying the number of passengers during the booking process.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 9}
              onChange={() => toggleAccordion(9)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 9 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Are there any discounts or promotions available when booking through BusArabia?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Yes, we regularly offer discounts and promotions on select routes and bus operators. Keep an eye on our website for the ongoing offers, promotions and discounts.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 10}
              onChange={() => toggleAccordion(10)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 10 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Can I modify or cancel my booking after it's been confirmed?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                The ability to modify or cancel bookings depends on the policies of the bus operator and the fare type selected during booking. Please refer to the specific terms and conditions provided during the booking process or contact our customer support team for assistance via live chat/call on our website or via whatsapp at 00971____________ or via email at customercare@busarabia.com
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 11}
              onChange={() => toggleAccordion(11)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 11 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Is it possible to select specific seats while booking tickets?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Seat selection options vary depending on the bus operator’s seat assignment procedures. Some bus operators may offer seat selection at the time of booking, while others may allow you to choose from the available seats upon boarding the bus at the time of departure (on first come first serve basis).
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 12}
              onChange={() => toggleAccordion(12)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 12 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  How do I book a bus ticket on Bus Arabia?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                To book a bus ticket on Bus Arabia, please follow these detailed steps:
                <ul>
                  <li>Visit Our Website: Open your web browser and go to our official website, Bus Arabia.</li>
                  <li>Select Your Destination: Use the search function to enter your departure and arrival locations.</li>
                  <li>Choose Your Travel Dates: Select the dates you wish to travel. You can specify both your departure and return dates if applicable.</li>
                  <li>Pick Your Preferred Bus Trip: Browse the available bus trips and schedules in the search results. Choose the one that best fits your travel plans.</li>
                  <li>Complete the Booking Process: Follow the on-screen instructions to fill in your personal details, select your seat, and make the payment. You will receive prompts to guide you through each step of the booking process.</li>
                </ul>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 13}
              onChange={() => toggleAccordion(13)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 13 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Can I book a bus ticket for someone else?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Yes, you can easily book a bus ticket for someone else. Here’s how:
                <ul>
                  <li>Start the Booking Process: Follow the initial steps as if you were booking a ticket for yourself.                </li>
                  <li>Enter Passenger Details: When prompted, enter the passenger's information instead of your own. This includes the passenger’s full name, contact information, and any other required details.</li>
                  <li>Complete the Payment: Proceed with the payment using your preferred method. The ticket will be issued in the name of the passenger you entered.</li>
                </ul>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 14}
              onChange={() => toggleAccordion(14)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 14 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  How do I get my bus ticket after booking online?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Once you have completed your booking online, you will receive your bus ticket as follows:
                <ul>
                  <li>Confirmation Email: An email confirmation will be sent to the email address provided during the booking process. This email will include all the details of your trip and your bus ticket</li>
                  <li>Print or Digital Ticket: You have the option to print the bus ticket or save it on your mobile device. When boarding the bus, you can present either the printed ticket or the digital version displayed on your mobile device.</li>
                </ul>
              </AccordionDetails>
            </Accordion>
          </div>}
        {rightFaq === 2 &&
          <div className="accoprdionOuter">
            <Accordion
              expanded={expandedAccordion === 15}
              onChange={() => toggleAccordion(15)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 15 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  What payment methods does BusArabia accept?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                We accept various payment methods, including debit/credit cards, online banking, and other secure payment gateways. The available payment options will be displayed during the checkout process.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 16}
              onChange={() => toggleAccordion(16)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 16 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  In which currency are payments accepted?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                While our prices are typically displayed in Saudi Riyals (SAR), we accept payments in all major currencies through our payment gateways. This flexibility ensures that customers from any country can conveniently make payments using their preferred currency without any hassles.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 17}
              onChange={() => toggleAccordion(17)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 17 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  How secure is the payment process on BusArabia?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                We prioritize the security of our users' payment information. Our website employs encryption technology and follows industry best practices to ensure secure transactions. Additionally, we partner with popular and trusted payment gateways to process payments securely.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 18}
              onChange={() => toggleAccordion(18)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 18 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Are there any additional fees associated with booking through BusArabia?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Our services are free for travelers. However, please note that bus operators may include applicable taxes, fees, or any additional charges in the ticket price, which will be clearly displayed during the booking process.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 19}
              onChange={() => toggleAccordion(19)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 19 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Will my payment information be stored on BusArabia's servers?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                We do not store payment information on our servers. All payment transactions are processed securely through popular and trusted third-party payment gateways, which ensure the confidentiality and security of your payment details.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 20}
              onChange={() => toggleAccordion(20)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 20 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  What measures does BusArabia take to protect my personal and financial information?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                We employ industry-standard security measures, including encryption protocols and firewall protection, to safeguard your personal and financial information against unauthorized access or disclosure.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 21}
              onChange={() => toggleAccordion(21)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 21 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  What steps should I take if payment is deducted from my account/card, but the transaction isn't completed, or I don't receive confirmation from Bus Arabia?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                If you encounter this issue, first check your email inbox (including spam/junk folders) for any confirmation messages from Bus Arabia. If you haven't received any confirmation despite the payment deduction, please don't hesitate to contact our customer support team immediately via live chat/call on our website or via whatsapp at 00971____________ or via email at customercare@busarabia.com . We'll dedicatedly investigate the matter, verify the status of your transaction and guide you in resolving the payment-related issue to ensure your peace of mind.
              </AccordionDetails>
            </Accordion>
          </div>}
        {rightFaq === 3 &&
          <div className="accoprdionOuter">
            <Accordion
              expanded={expandedAccordion === 22}
              onChange={() => toggleAccordion(22)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 22 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  How does BusArabia select the bus operators listed on the platform?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                We carefully vet bus operators based on factors such as reliability, safety record, service quality, and customer feedback to ensure excellent services and experience for our users.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 23}
              onChange={() => toggleAccordion(23)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 23 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Can I trust the reliability and safety of the bus operators listed on BusArabia?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Yes, we (Bus Arabia) partner with reputed bus operators that comply with safety regulations and maintain high service standards. However, if you encounter any issues, please notify us, and we shall ensure to address them promptly.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 24}
              onChange={() => toggleAccordion(24)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 24 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Do bus operators listed on BusArabia offer amenities like Wi-Fi, onboard entertainment, or refreshments?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Amenities vary by bus operator and type of bus selected. Amenities offered are varied such as Wi-Fi, onboard entertainment, refreshments, lavatory in bus, charging ports, etc. You can view detailed information about amenities while selecting your ticket from the search results page as well as on the bus operator's profile page.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 25}
              onChange={() => toggleAccordion(25)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 25 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Can I view reviews or ratings for specific bus operators?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Yes, we provide a platform for travelers to leave reviews and ratings based on their bus travel experiences with different bus operators. You can access these reviews and ratings to make informed decisions when booking your bus tickets.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 26}
              onChange={() => toggleAccordion(26)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 26 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  What should I do if I encounter issues with a bus operator's service?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                If you encounter any issues with a bus operator's service, please contact our customer support team, and we will assist you in resolving the issue with the operator.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 27}
              onChange={() => toggleAccordion(27)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 27 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  How can I find the departure and arrival stations for my bus operator?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                After successfully completing your booking on our website, we provide you with convenient Google Maps location links for both the departure and arrival stations. These links are designed to make it easy for you to navigate to the exact locations of your bus operator's stations, ensuring a smooth travel experience.
              </AccordionDetails>
            </Accordion>


          </div>}
        {rightFaq === 4 &&
          <div className="accoprdionOuter">
            <Accordion
              expanded={expandedAccordion === 28}
              onChange={() => toggleAccordion(28)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 28 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Is it mandatory to provide my passport or ID information when booking tickets?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Yes, for certain routes and destinations, it may be required to provide passport or ID information as per local government regulations. This ensures compliance with travel requirements and facilitates smooth boarding and traveling procedures.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 29}
              onChange={() => toggleAccordion(29)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 29 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Will I receive a confirmation email or ticket after booking?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Yes, upon successful booking, you will receive a confirmation email containing your ticket details. You can present this confirmation email or ticket at the bus station for boarding.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 30}
              onChange={() => toggleAccordion(30)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 30 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  How early should I arrive at the bus station before departure?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                We recommend arriving at the bus station at least 30 minutes to an hour before the scheduled departure time to complete check-in procedures smoothly and ensure timely boarding.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 31}
              onChange={() => toggleAccordion(31)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 31 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Are there any luggage restrictions I should be aware of?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Luggage restrictions may vary by bus operator and type of bus selected. It's advisable to check the baggage allowance and restrictions provided by the bus operators before booking your bus ticket to avoid any inconvenience.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 32}
              onChange={() => toggleAccordion(32)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 32 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Can I bring pets or oversized baggage on board?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Policies regarding pets and oversized baggage may vary by bus operator and type of bus selected. We recommend referring to the terms and conditions of different bus operators for specific guidelines regarding pets and oversized baggage.
              </AccordionDetails>
            </Accordion>
          </div>}
        {rightFaq === 5 &&
          <div className="accoprdionOuter">
            <Accordion
              expanded={expandedAccordion === 33}
              onChange={() => toggleAccordion(33)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 33 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  What should I do if I encounter technical difficulties while using the BusArabia website?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                If you encounter technical difficulties, please try refreshing the page or clearing your browser cache. If the issue persists, you can reach out to our customer support team via live chat/call on our website or via whatsapp at 00971____________ or via email at customercare@busarabia.com for assistance.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 34}
              onChange={() => toggleAccordion(34)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 34 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Is there a mobile app available for booking bus tickets?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Currently, we do not have a dedicated mobile app. However, our website is mobile-friendly, allowing you to book bus tickets conveniently from your smartphone or tablet as well.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 35}
              onChange={() => toggleAccordion(35)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 35 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Can I make changes to my booking through the BusArabia app?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Whether you can change your booking depends on the bus company and the type of ticket purchased by you. This can be found in the bus operator’s terms and conditions when you book your bus ticket, you may also contact our customer support team if you need further assistance in this regards. You can reach out to our customer support team for assistance via live chat/call on our website or via whatsapp at 00971____________ or via email at customercare@busarabia.com
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 36}
              onChange={() => toggleAccordion(36)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 36 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  How can I reset my password if I forget it?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                If you forget your password, you can easily reset it by clicking on the "Forgot Password" link on the login page. Then follow the instructions provided to reset your password securely.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 37}
              onChange={() => toggleAccordion(37)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 37 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Does BusArabia offer customer support via phone or live chat?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Currently, our primary customer support channels are live chat on our website, whatsapp at 00971____________ , email customercare@busarabia.com for traveler’s inquiries and email admin@busarabia.com for vendor and B2B interactions. We shall also explore additional support channels in the future.
              </AccordionDetails>
            </Accordion>
          </div>}
        {rightFaq === 6 &&
          <div className="accoprdionOuter">
            <Accordion
              expanded={expandedAccordion === 38}
              onChange={() => toggleAccordion(38)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 38 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  How does BusArabia protect my personal information?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                We prioritize the protection of your personal information and adhere to strict security protocols to prevent unauthorized access, disclosure, or misuse of data. Your information is encrypted and stored securely in compliance with applicable data protection laws.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 39}
              onChange={() => toggleAccordion(39)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 39 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Will my personal information be shared with third parties?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                We respect your privacy and only share your personal information with trusted third parties, such as bus operators and payment processors for the purpose of facilitating your bookings and transactions. We do not sell or rent your information to third parties for marketing purposes.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 40}
              onChange={() => toggleAccordion(40)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 40 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  How long does BusArabia store my booking history and personal data?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                We retain your booking history and personal data for as long as necessary to fulfill the purposes outlined in our Privacy Policy and to comply with legal obligations. You can review our Privacy Policy for more information on data retention practices.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 41}
              onChange={() => toggleAccordion(41)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 41 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  What should I do if I suspect unauthorized activity on my BusArabia account?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                If you suspect unauthorized activity on your account, such as unauthorized bookings or changes to your personal information, please contact our customer support team immediately via live chat/call on our website or via whatsapp at 00971____________ or via email at customercare@busarabia.com. We will investigate the issue and take immediate steps to secure your account.
              </AccordionDetails>
            </Accordion>
          </div>}
        {rightFaq === 7 &&
          <div className="accoprdionOuter">
            <Accordion
              expanded={expandedAccordion === 42}
              onChange={() => toggleAccordion(42)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 42 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  What is the refund policy for canceled tickets?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Refund policies may vary depending on the bus operator, the type of ticket purchased by you and the time of cancellation or claim of refund. Refunds are subject to the terms and conditions of the ticket purchased. Partial or full refunds may be issued based on the cancellation and refund policy of bus operators associated with your booking.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 43}
              onChange={() => toggleAccordion(43)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 43 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  How long does it take to process a refund from BusArabia?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Refund processing times may vary depending on the payment method and financial institution involved. Typically, refunds are processed within a few business days after the cancellation request is approved. However, it may take longer for the refund to reflect in your account due to bank working days and processing times.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 44}
              onChange={() => toggleAccordion(44)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 44 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Are there any fees associated with canceling or changing my booking?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Cancelation and change fees may apply depending on the bus operator, the type of ticket purchased by you and the time when a change in booking was requested by you. Some bookings may be non-refundable or subject to a cancellation fee, while others may allow free cancellations or changes within a specified timeframe. Please review the terms and conditions and policies of bus operators associated with your booking for applicable fees.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 45}
              onChange={() => toggleAccordion(45)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 45 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  Can I get a refund if my bus is delayed or canceled?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                In the event of a bus delay or cancellation by the bus operator, passengers may be entitled to a full or partial refund, depending on the circumstances and the bus operator's policies. Usually, BusArabia will work with the bus operator to facilitate refunds for affected passengers in such situations.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 46}
              onChange={() => toggleAccordion(46)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 46 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  What happens if I miss my scheduled bus departure?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                If you miss your scheduled bus departure, please contact our customer support team as soon as possible. Depending on availability and the bus operator's policies, you may be able to rebook your ticket for the next available trip or a later scheduled departure time, subject to any applicable fees or fare differences.
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedAccordion === 47}
              onChange={() => toggleAccordion(47)}
            >
              <AccordionSummary
                expandIcon={
                  expandedAccordion === 47 ? (
                    <FaMinus className="minusColor" />
                  ) : (
                    <FaPlus className="minusColor" />
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="faqHeading">
                  What should I do if there is a dispute regarding my booking, travel, or any other issue?
                </div>
              </AccordionSummary>
              <AccordionDetails>
                Our dedicated customer support team is here to assist you with any concerns or disputes you may have regarding your booking or travel arrangements. Please don't hesitate to reach out to our customer support team immediately via live chat/call on our website or via whatsapp at 00971____________ or via email at customercare@busarabia.com and we shall ensure to resolve the issue promptly and to your satisfaction.
              </AccordionDetails>
            </Accordion>
          </div>}
      </div>
    </>
  );
};

export default FAQWeb;
